export default __webpack_public_path__ + "static/media/dota2.3ae24a74.png";